import {
  DELETE_HS_CODE,
  EDIT_HS_CODE,
  ADD_HS_CODE,
  GET_HS_CODE,
} from "../../Types";
const initialState = {
  hs_code: [],
};

function hsCode(state = initialState, action) {
  switch (action.type) {
    case ADD_HS_CODE: {
      return {
        ...state,
        hs_code: [...state.hs_code, action.payload],
      };
    }
    case GET_HS_CODE: {
      const totalHscode = action.payload;
      return { ...state, hs_code: totalHscode };
    }
    case EDIT_HS_CODE: {
      let updateHsCode = state.hs_code.map((item) =>
        item.hs_code_id === action.payload.hs_code_id ? action.payload : item
      );
      return {
        ...state,
        hs_code: updateHsCode,
      };
    }
    case DELETE_HS_CODE: {
      const after_delete_hsCode = state.hs_code.filter(
        (hs_code) => hs_code.hs_code_id !== action.payload.hs_code_id
      );
      return { ...state, hs_code: after_delete_hsCode };
    }
    default:
      return state;
  }
}

export default hsCode;
